/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

// export var Globals = {};

export var Status = {
	CONNECTED: 1,
	DISCONNECTED: 2
};

export var ErrorTypes = {
	DISCONNECT: '1000',
	GENERAL_ERROR: '100',
	INVALID_MESSAGE: '101',
	INVALID_SERVICE: '102',
	CONCURRENT_CONNECTION: '103',
	ALREADY_LOGGED_IN: '104',
	NOT_LOGGED_IN: '105',
	SESSION_CLOSED: '105',
	INVALID_TRANSFER: '106',
	INVALID_BET_AMOUNT: '107',
	INSUFFICIENT_FUNDS: '108',
	INVALID_BET: '109',
	INVALID_SESSION: '110',
	MAX_BET_LIMIT: '115',
	BET_TIMEOUT: '112',
	FREESPIN_ERROR: '117',
	FREESPIN_EXPIRED: '118'
};

export const EVENTS = {
	LANGUAGE_CHANGED: 'language_change_event',
	REEL_FINISHED: 'reel_finished',
	REEL_STARTED: 'reel_started',
	LINE_STARTED: 'line_started',
	LINE_FINISHED: 'line_finished',
	ALL_LINES_FINISHED: 'allline_finished',
	REEL_CAN_STOP: 'reel_can_stop',
	MODAL: 'modal',
	WIN_HIGHLIGHT: 'win_hightlight',
	AUTO_STARTED: 'auto_started',
	SETTINGS_UPDATE: 'settings_update',
	SERVER_MSG: 'server_msg',
	ERROR_MSG: 'error_msg',
	ERROR_PAGE: 'error_page',
	NOTIFICATION: 'notification',
	BET_UPDATE: 'bet_update',
	BONUS_ROUND_STATE: 'bonus_round_state',
	DOUBLE_CHANCE: 'double_chance',
	BET_PLACED: 'bet_placed',
	PAUSE: 'pause',
	START_GAME: 'start_game',
	BONUS_BUY: 'bonus_buy',
	INTERACTION: window.isMobile || window.isTablet ? 'tap' : 'click',
	QUEST_CLAIM: 'quest_claim',
	QUEST_UPDATE: 'quest_update',
	QUEST_END: 'quest_end',
	FREESPIN: 'freespin',
	HAS_QUEST: 'has_quest',
	QUEST_CAN_CLAIM: 'quest_can_claim',
	BONUS_RESTORE: 'bonus_restore',
	IS_DISABLED: 'disable',
	BAIT: 'bait',
	MAIN_LINE_FINISHED: 'main_line_finished',
	ICON_CLICKED: 'icon_clicked',
	INFO: 'info'
	// CLICKABLE: 'clickable'
};

export const COMPONENTS = {
	QUEST_WIDGET: 'quest_widget_holder',
	QUEST_PAGE: 'quest_page_holder',
	QUEST_PAGE_CLAIM: 'quest_page_claim_holder',
	BONUS_BUY_WIDGET: 'bonus_buy_widget_holder',
	BONUS_BUY_PAGE: 'bonus_buy_page_holder',
	BONUS_REVIVE_PAGE: 'bonus_revive_page_holder',
	NOTIFICATION: 'notification_holder',
	SETTINGS_PAGE: 'settings_page_holder',
	INFO_PAGE: 'info_page_holder',
	AUTO_SPIN: 'auto_spin_page_holder',
	WIN_HIGHLIGHT: 'win_highlight_holder',
	FAST_PLAY_DIALOGUE: 'fast_play_dialogue_holder',
	FREE_SPIN_WIN: 'free_spin_win_holder',
	BONUS_GAME_DIALOGUE: 'bonus_game_dialogue_holder',
	BONUS_GAME_FINISHED_DIALOGUE: 'bonus_game_finished_holder',
	DOUBLE_CHANCE_WIDGET: 'double_chance_widget_holder',
	LOGO: 'logo_holder',
	BET_AMOUNT: 'bet_amount_holder',
	STATUS_BAR: 'status_bar_holder',
	STATUS_BAR_BG: 'status_bar_bg_holder',
	STATUS_BAR_BG_DESKTOP: 'status_bar_bg_holder_desktop',
	INFO_BUTTONS: 'info_buttons_holder',
	SPIN_BUTTONS: 'spin_buttons_holder',
	REEL: 'reel_holder',
	BONUS_GAME: 'bonus_game_holder',
	PROMPT: 'prompt_holder',
	QUEST_PROMPT: 'quest_prompt_holder',
	FREESPIN_PROMPT: 'freespin_prompt_holder',
	FREESPIN_STATUS_BAR: 'freespin_status_bar_holder',
	QUEST_STATUS_BAR: 'quest_status_bar_holder',
	BONUS_TRIGGER: 'bonus_trigger_holder',
	WIN_AMOUNT: 'win_amount_holder',
	WIN_INFO: 'win_info_holder'
};

export const NOTIFICATIONS = {
	100: {
		title: 'notifications.generalErrorTitle',
		desc: 'notifications.generalErrorDescription'
	},
	101: {
		title: 'notifications.invalidMessageTitle',
		desc: 'notifications.invalidMessageDescription'
	},
	102: {
		title: 'notifications.invalidServiceTitle',
		desc: 'notifications.invalidServiceDescription.'
	},
	103: {
		title: 'notifications.anotherLoginTitle',
		desc: 'notifications.anotherLoginDescription'
	},
	106: {
		title: 'notifications.invalidTransferTitle',
		desc: 'notifications.invalidTransferDescription'
	},
	107: {
		title: 'notifications.invalidBetAmountTitle',
		desc: 'notifications.invalidBetAmountDescription'
	},
	108: {
		title: 'notifications.insufficientFundsTitle',
		desc: 'notifications.insufficientFundsDescription'
	},
	109: {
		title: 'notifications.invalidBetTitle',
		desc: 'notifications.invalidBetDescription'
	},
	110: {
		title: 'notifications.invalidSessionTitle',
		desc: 'notifications.invalidSessionDescription'
	},
	112: {
		title: 'notifications.betTimeoutTitle',
		desc: 'notifications.betTimeoutDescription'
	},
	1112: {
		title: 'notifications.timeOutTitle',
		desc: 'notifications.timeOutDescription'
	},
	115: {
		title: 'notifications.betLimitTitle',
		desc: 'notifications.betLimitDescription'
	},
	117: {
		title: 'notifications.freeSpinTitle',
		desc: 'notifications.freeSpinDescription'
	},
	//TODO, get code
	118: {
		title: 'notifications.expiredSpinTitle',
		desc: 'notifications.expiredSpinDescription'
	}
};

export const ERROR_TEXTS = {
	1000: 'errors.expiredSession',
	100: 'errors.smtWrong',
	101: 'errors.expiredSession',
	103: 'errors.concurrentConnect',
	105: 'errors.loginToContinue',
	110: 'errors.expiredSession',
	111: 'errors.expiredSession',
	113: 'errors.expiredSession'
};

export const colors = {
	primary: '#DEB2BF',
	secondary: '#DF215A',
	highlight: '#FAF23E',
	win: '#69AB15'
};
